import axios from 'axios'

const getBaseUrl = () => {
    if (window.location.hostname.includes('dev')){
        console.log('using https://dev.api.energilitydx.com/')
        return 'https://dev.api.energilitydx.com/'        
    }

    if (window.location.hostname.includes('test')){
        console.log('using https://test.api.energilitydx.com/')
        return 'https://test.api.energilitydx.com/'
    }

    if (window.location.hostname.includes('app')){
        console.log('using https://api.energilitydx.com/')
        return 'https://api.energilitydx.com/'
    }
  
    console.log('using localhost')
    return 'http://localhost:5109/'        
}

const app = axios.create({
    baseURL: getBaseUrl(),
    headers: {
        'Content-Type': 'application/json',
    },
})

export default app;
